/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SativaInputs */

const en_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sativa`)
};

const th_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซาติว่า`)
};

const ja_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サティバ`)
};

const fr_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sativa`)
};

const es_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sativa`)
};

const ru_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сатива`)
};

const zh_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萨提瓦`)
};

const vi_sativa = /** @type {(inputs: SativaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sativa`)
};

/**
* | output |
* | --- |
* | "Sativa" |
*
* @param {SativaInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const sativa = /** @type {((inputs?: SativaInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SativaInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sativa(inputs)
	if (locale === "ja") return ja_sativa(inputs)
	if (locale === "fr") return fr_sativa(inputs)
	if (locale === "es") return es_sativa(inputs)
	if (locale === "ru") return ru_sativa(inputs)
	if (locale === "zh") return zh_sativa(inputs)
	if (locale === "vi") return vi_sativa(inputs)
	return en_sativa(inputs)
});